<div [class.is-personalized-layout]="!!layoutVars">
  <div class="card card-offer-evaluation mb-3" [ngClass]="{'light': theme == 'light'}"
    *ngIf="(vehicle.status !== 'SOLD' && vehicle.status !== 'DELETED') || fastQuoteHasBids() || vehicle.fastQuote?.stats">
    <div class="card-body" [style.min-width]="(!accordionActive && theme !== 'light') || blockSellerSeeOffers ? '23rem' : '' ">
      <div class="row mb-3">
        <div class="col-md-8 value">
          <h3><i class="app-icon-fast-lightning"></i>COTAÇÃO RÁPIDA</h3>
        </div>
        <div class="col-md-4 text-right" *ngIf="theme == 'light' && vehicle.status !== 'DELETED'">
          <mat-slide-toggle *ngIf="vehicle.status != 'SOLD'" [(ngModel)]="showFastQuoteDetail"
            (change)="onValChange(showFastQuoteDetail)" aria-labelledby="slider-label"
            [disabled]="loading || showFastQuoteDetail">
          </mat-slide-toggle>
        </div>
        <span style="cursor: pointer;" *ngIf="theme != 'light'">
          <i class="material-icons" style="font-size:24px" (click)="accordionActive = !accordionActive">
            {{accordionActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
        </span>
      </div>
      <div class="row" *ngIf="vehicle.status !== 'DELETED'" [style.display]="accordionActive || theme == 'light' ? 'block' : 'none'">
        @if (isFastQuote()) {
        <div class="col-md-12 mt-2">
          @if (!expiredFastQuote && canViewPotentialBuyers()) {
          <div class="potential-dealers-container">
            <div class="potential-dealers-label">
              <i class="fa-solid fa-user-friends"></i>
              <span>Potenciais compradores</span>
              <i
                class="fa-regular fa-circle-info"
                matTooltip="Total de lojistas que demonstraram interesse recente em veículos com características similares a este."
              ></i>
            </div>
            <button
              type="button"
              class="see-all"
              (click)="openPotentialDealersDialog()"
            >
              ver todos
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
          }
          <div class="col-tempo-end">
            <i class="material-icons">timer</i>
            {{(vehicle.expirationTimeLeft > 0) ? 'Finaliza' : 'Finalizado'}} em {{vehicle.fastQuote?.expiration | date}}
            às
            {{vehicle.fastQuote?.expiration | date: 'shortTime'}}
          </div>
        </div>
      }
        <div class="col-12 mt-2 mb-2" *ngIf="isFastQuote()">
          <strong>Público alvo:</strong> {{getTargetLabel(vehicle.fastQuote?.target)}}
          <div class="selected-group-list mt-2" *ngIf="selectedGroups && selectedGroups.length > 0">
            <div class="group-title" *ngIf="showFastQuoteDetail">GRUPOS SELECIONADOS</div>
            <div class="group-item" *ngFor="let group of selectedGroups; let i = index">
              {{group.name}}
            </div>
          </div>
        </div>
        <div class="col-12 mt-2 mb-2" *ngIf="isFastQuote()">
          <strong>Tipo de proposta:</strong> {{vehicle.fastQuote?.isAuction ? 'Competitiva' : 'Padrão'}}
        </div>
        <div class="col-12 mt-2 mb-2" *ngIf="isFastQuote() && vehicle.fastQuote?.bidStep">
          <strong>Bid Step:</strong> R$ {{vehicle.fastQuote?.bidStep | number}}
        </div>

        <div class="col-md-12">
          <p *ngIf="!isFastQuote() && vehicle.status !== 'SOLD'">Os dados do seu veículo serão enviados para uma base de
            potenciais compradores e em pouco tempo você receberá opções de ofertas para escolher.</p>
          <p *ngIf="vehicle.fastQuote?.waitingDecision && fastQuoteHasBids()">
            O comprador está esperando! Sua cotação rápida foi finalizada, mas ainda não escolheu nenhuma oferta.
            Selecione uma proposta para concluir a venda e fechar o negócio o quanto antes.
          </p>
          <p *ngIf="vehicle.fastQuote?.pendingPayment && !isCommissionPaid()">
            Parabéns, a sua cotação rápida está finalizada e the comprador escolhido já foi notificado! Aguarde, quando a
            fee plataforma
            emitida pela Auto Arremate for pago, the seu retorno será creditado.
          </p>
          @if (isCommissionPaid()) {
            <div class="commission-paid">
              <div class="commission-paid-title">
                <i class="material-icons">check_circle</i>FEE PLATAFORMA PAGA
              </div>
              <div class="commission-paid-info">
                <span class="commission-paid-label">Pago em</span>
                <span class="commission-paid-value">
                  {{ vehicle.fastQuote.commissionPaidAt | date: "dd/MM/yyyy" }} às
                  {{ vehicle.fastQuote.commissionPaidAt | date: "HH:mm" }}
                </span>
                @if (hasCommissionValue()) {
                  <span class="commission-paid-label">Valor</span>
                  <span class="commission-paid-value">R$ {{ getCommissionValue() | number: '1.2-2' }}</span>
                }
              </div>
            </div>
          }
          <ng-container
            *ngIf="(vehicle.status === 'SOLD_FAST_QUOTE' || vehicle.status === 'SOLD') && vehicle.bankSlipUrl && !isCommissionPaid()">
            <a (click)="openPayment()" tabindex="0" role="button" class="btn btn-primary btn-boleto">{{ isSuperbidLink ? 'COPIAR LINK DO CHECKOUT' : 'VER FEE PLATAFORMA' }}</a>
          </ng-container>
          <div class="mt-2" *ngIf="canShowCancelAuctionButton()">
            <button class="btn btn-link btn-block" (click)="openCancelAuctionModal()" [disabled]="loadingCancel">
              Cancelar venda
            </button>
          </div>
          <!-- <div class="message-box mx-auto mt-2" (click)="openInvoicePaidModal()" style="cursor: pointer; text-align: center;" *ngIf="isAdmin && !comissionPaid && vehicle.status == 'SOLD' " >
            <i class="material-icons">enhanced_encryption</i>
            Marcar esta taxa como paga
          </div> -->
          @if (fastQuoteHasBids() && !blockSellerSeeOffers && canViewFastQuoteProposals()) {
            <div class="offer-list">
              @for (bid of vehicle.fastQuote?.bidSuggestions ?? []; track trackFastQuoteBid($index, bid); let i = $index) {
                <app-fast-quote-offer
                  [vStatus]="vehicle.status ?? ''"
                  [theme]="theme"
                  [vehicle]="bid"
                  [eval]="vehicle"
                  [userInfo]="userInfo"
                  [fastQuoteId]="vehicle.fastQuoteId ?? ''"
                  [index]="i">
                </app-fast-quote-offer>
              }
            </div>
          } @else if (isFastQuote() && vehicle.expirationTimeLeft > 0 && !blockSellerSeeOffers) {
            <div class="no-offer">
              @if (canViewFastQuoteProposals()) {
                Sua cotação rápida está ativa, mas você ainda não recebeu nenhuma oferta.
              } @else {
                Você não tem permissão para visualizar as propostas.
              }
            </div>
          }
        </div>
        <div class="col-md-12 mt-2">
          <div class="text-info-value underline pointer" (click)="openModal()">
            Veja as regras da cotação rápida
          </div>
        </div>
        <div class="col-12 mt-3" *ngIf="(!isFastQuote() && !soldFastQuote())">
          <label style="font-size: 11px;">Público alvo</label>
          <div class="radio-button-group target-public">
            <mat-radio-group [(ngModel)]="selectedTarget" aria-label="Selecione uma opção" name="target" required
              #target="ngModel">
              <mat-radio-button *ngFor="let target of allTargets" [value]="target">{{getTargetLabel(target)}}
              </mat-radio-button>
            </mat-radio-group>
            <span class="include-exclusive-group"
                  *ngIf="selectedTarget != 'ALL' && selectedTarget != 'EXCLUSIVE_GROUPS'"
                  (click)="includeExclusiveGroups = !includeExclusiveGroups">Incluir grupos exclusivos</span>
          </div>
        </div>
        <div class="col-md-12" *ngIf="!showFastQuoteDetail && ((selectedTarget != 'ALL' && includeExclusiveGroups) || selectedTarget == 'EXCLUSIVE_GROUPS')">
          <div class="exclusive-group">
            <mat-form-field appearance="fill" *ngIf="!showFastQuoteDetail">
              <mat-label>Selecione o grupo exclusivo</mat-label>
              <mat-select (selectionChange)="selectExcGroup()" [(ngModel)]="exclusiveGroupInput">
                <mat-option *ngFor="let group of exclusiveGroups;" [value]="group">
                  {{group.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="selected-group-list" *ngIf="selectedGroups.length > 0">
              <div class="group-title" *ngIf="showFastQuoteDetail">GRUPOS SELECIONADOS</div>
              <div class="group-item" *ngFor="let group of selectedGroups; let i = index">
                {{group.name}}
                <i class="material-icons" matTooltip="Remover grupo" (click)="removeSelected(i)"
                  *ngIf="!showFastQuoteDetail">close</i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3" *ngIf="(!isFastQuote() && !soldFastQuote())">
          <label style="font-size: 11px;">Tipo de proposta <i class="material-icons" [matTooltip]="proposalTypeInfo" [matTooltipClass]="'tooltip-class'">info</i></label>
          <div class="radio-button-group">
            <mat-radio-group class="d-flex gap-3"[(ngModel)]="isAuction" required [disabled]="vehicle.defaultCompetitiveFastQuote">
              <mat-radio-button [value]="false">Padrão</mat-radio-button>
              <mat-radio-button [value]="true">Competitiva</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="col-md-12 mt-2 min-value-container"
          *ngIf="(!isFastQuote() && !soldFastQuote()) && (vehicle.fastQuote?.bidStep || isAuction)">
          <label style="font-size: 11px;">BID STEP <span *ngIf="!isFastQuote() && !soldFastQuote()">&nbsp;(opcional)</span>
          </label>
          <mat-form-field style="margin-top: -24px;" *ngIf="!isFastQuote() && !soldFastQuote()">
            <span matPrefix class="currency-symbol">R$&nbsp;</span>
            <input [formControl]="bidStepControl" matInput currencyMask [min]="bidStepControl.value ? 100 : null" [options]="{
                prefix: '',
                thousands: '.',
                precision: 0,
                allowNegative: false
              }" type="tel" />
            <mat-icon matSuffix style="font-size: 24px; color: var(--on-title-color, #ffffff);">mode_edit</mat-icon>
            <mat-error *ngIf="bidStepControl.hasError('min')">O valor mínimo é R$ 100</mat-error>
          </mat-form-field>
          <div class="min-value" *ngIf="(isFastQuote() || soldFastQuote()) && vehicle.fastQuote?.bidStep">
            <span class="currency-symbol">R$ </span>{{vehicle.fastQuote.bidStep | number}}
          </div>
        </div>
        <div class="col-md-12 min-value-container"
          *ngIf="(!isFastQuote() && !soldFastQuote()) || vehicle.fastQuote?.minBidValue">
          <label style="font-size: 11px;">VALOR MÍNIMO <span *ngIf="!isFastQuote() && !soldFastQuote()">&nbsp;(opcional)</span>
          </label>
          <mat-form-field style="margin-top: -24px;" *ngIf="!isFastQuote() && !soldFastQuote()">
            <span matPrefix class="currency-symbol">R$&nbsp;</span>
            <input [formControl]="minPriceControl" matInput currencyMask [options]="{
                prefix: '',
                thousands: '.',
                precision: 0,
                allowNegative: false
              }" type="tel" />
            <mat-icon matSuffix style="font-size: 24px; color: var(--on-title-color, #ffffff);">mode_edit</mat-icon>
          </mat-form-field>
          <div class="min-value" *ngIf="(isFastQuote() || soldFastQuote()) && vehicle.fastQuote?.minBidValue">
            <span class="currency-symbol">R$ </span>{{vehicle.fastQuote.minBidValue | number}}
          </div>
        </div>

        <div class="col-md-12 time-value-container" *ngIf="longFastQuote && !isFastQuote() && !soldFastQuote()">
          <label style="font-size: 11px;">HORÁRIO DE FECHAMENTO <span
              *ngIf="!isFastQuote() && !soldFastQuote()">&nbsp;(opcional)</span></label>
          <mat-form-field *ngIf="!isFastQuote() && !soldFastQuote()" style="margin-top: -20px;">
            <input [formControl]="personalizedFinishTime" matInput type="text" />
            <mat-hint>Usar hh:mm. Por exemplo: 17:30</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-md-12 mt-3 d-flex flex-column gap-1">
          <button class="btn btn-primary btn-rounded btn-block"
            *ngIf="(canPublish() || canReactive()) && !soldFastQuote() && theme != 'light'" [disabled]="loading"
            (click)="sendFastQuote()">
            <div class="btn-spinner float-left" *ngIf="loading"></div>
            <span>
              {{ !expiredFastQuote ? 'ENVIAR PARA COTAÇÃO RÁPIDA' : 'REATIVAR COTAÇÃO RÁPIDA' }}
            </span>
          </button>
          <button class="btn btn-outline-primary btn-rounded btn-block"
            *ngIf="vehicle.inFastQuote"
            [disabled]="loading" (click)="openCancelFastQuoteConfirmation()">
            <div class="btn-spinner float-left" *ngIf="loading"></div>
            <span>
              {{!expiredFastQuote ? 'CANCELAR COTAÇÃO RÁPIDA' : 'ABANDONAR COTAÇÃO RÁPIDA'}}
            </span>
          </button>
          @if (canShowDirectSale()) {
            <div class="w-100 mt-2">
              <button class="btn btn-outline-admin btn-block btn-rounded" (click)="openDirectSaleDialog()">Venda direta</button>
            </div>
            }
        </div>
      </div>

      <div class="mt-16" *ngIf="historyItems && !blockSellerSeeOffers" [style.display]="accordionActive ? 'block' : 'none'">
        <div class="history-item">
          <ul>
            <li *ngFor="let item of historyItems">
              <div class="label">
                <span>
                  {{ getEventText(item) }}
                </span>
                <div *ngIf="item.bid">
                  <ng-container *ngIf="item.type === 'ACTIVATED'">Valor mínimo: </ng-container>
                  R$ {{ item.bid | number }}
                </div>
                <div *ngIf="item.dealerName">
                  Comprador: {{ item.dealerName}}
                </div>
                <div>
                  {{ item.createdAt | amTimeAgo }}
                </div>
              </div>
            </li>
            <li *ngIf="additionalHistoryItems > 0">
              <span class="label view-all-link" (click)="enableAllHistoryItems()">
                ver todos (+{{ additionalHistoryItems }})
              </span>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <div class="card-footer" *ngIf="showStats()"  [style.display]="accordionActive ? 'block' : 'none'">
      <div class="row">
        <div class="col-md-4 border-r-dot">
          <div class="quote-info">
            <span
              class="number">{{vehicle.fastQuote.stats.uniqueImpressions ? vehicle.fastQuote.stats.uniqueImpressions : 0}}</span>
            <i class="app-icon-graph"></i><br />
            impressões
          </div>
        </div>
        <div class="col-md-4 border-r-dot">
          <div class="quote-info">
            <span class="number">{{vehicle.fastQuote.stats.uniqueViews ? vehicle.fastQuote.stats.uniqueViews : 0}}</span>
            <i class="app-icon-board"></i><br />
            visualizações
          </div>
        </div>
        <div class="col-md-4 border-r-dot">
          <div class="quote-info">
            <span class="number">{{vehicle.fastQuote.bidSuggestions ? vehicle.fastQuote.bidSuggestions.length : 0}}</span>
            <i class="app-icon-tag"></i><br />
            ofertas
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="margin-top: 8px; margin-bottom: 16px;" *ngIf="vehicle.fastQuote?.stats?.uniqueViews > 0" [style.display]="accordionActive || theme == 'light' ? 'block' : 'none'">
    <app-card-interested-dealers [fastQuote]="vehicle.fastQuote" [vehicle]="vehicle">
    </app-card-interested-dealers>
  </div>
</div>

